package fyi.moko.hotpl.domain.model

data class PlaceVisitSummary(
    val placeId: String,
    val visitCount: Int,
    val lastVisitedAt: Long,
    val emotion: Emotion? = null,
)